import React, { useContext } from 'react';
import { SnackBarMessage } from '@eposnow/ui-core';
import { useTheme } from '@mui/material';
import { DataGridConfigContext } from '../../context/DataGridConfigContext';
import { UserContext } from '../../context/UserContext';
import { UIContext } from '../../context/UIContext';

const GridSnackbarMessage = () => {
  const theme = useTheme();
  const { locale } = useContext(UserContext);
  const { isMobile } = useContext(UIContext);
  const { successMessage, setSuccessMessage } = useContext(DataGridConfigContext);

  return (
    <SnackBarMessage
      message={successMessage}
      setMessage={setSuccessMessage}
      isMobile={isMobile}
      theme={theme}
      locale={locale}
    />
  );
};

export default GridSnackbarMessage;
